module.exports = __webpack_public_path__ + "/fonts/rw-widgets.eot";


//////////////////
// WEBPACK FOOTER
// ./app/fonts/rw-widgets.eot
// module id = 632
// module chunks = 0